export function OutlineFastBackward2Icon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4175 13.4085L9.99941 16.8227L6.40854 20.4144C5.15077 21.666 3.00009 20.7789 3.00009 19.0046V4.99752C3.00009 3.22325 5.15077 2.33132 6.40854 3.58769L9.99941 7.17459L13.4175 10.5888C14.1952 11.3705 14.1952 12.6316 13.4175 13.4085Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4167 13.4085L13.4078 20.4144C12.15 21.666 9.99936 20.7789 9.99936 19.0046V16.8227L13.4174 13.4085C14.1951 12.6316 14.1951 11.3705 13.4174 10.5888L9.99936 7.17459V4.99752C9.99936 3.22325 12.15 2.33132 13.4078 3.58769L20.4167 10.5888C21.1944 11.3705 21.1944 12.6316 20.4167 13.4085Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9976 3.00781V20.9902"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
